"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushToDataLayer = void 0;
function pushToDataLayer(event) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    window.dataLayer.push(event);
}
exports.pushToDataLayer = pushToDataLayer;
//# sourceMappingURL=pushToDataLayer.js.map